let picList = [
  '/static/wuxi/8.png',

  '/static/wuxi/7.png',

  '/static/wuxi/6.png',

  '/static/wuxi/5.png',

  '/static/wuxi/4.png',

  '/static/wuxi/3.png',

  '/static/wuxi/2.png',

  '/static/wuxi/1.png'
]

if(process.env.VUE_APP_KEY === 'SzTech') {
  picList = [
    '/static/SzTech_365/1.png',
    '/static/SzTech_365/2.png',
    '/static/SzTech_365/3.png',
    '/static/SzTech_365/4.png',
  ]
}

const fields = [
  {
    dataIndex: 'key',
    key: 'key',
    title: '排名',
    width: 80
  },
  {
    dataIndex: 'name',
    key: 'name',
    title: '申请人'
  },
  {
    dataIndex: 'value',
    key: 'value',
    width: 100,
    title: '数量'
  }
]

module.exports = {
  picList,
  fields
}
